import GraficoProdutividade from '../GraficoProdutividade'
import GraficoNpsAtendimento from '../GraficoNpsAtendimento'
import ResumoTarefas from '../ResumoTarefas'
import UltimosAtendimentos from '../UltimasAtividadesConcluidas'
import './meupainel.css'
import Permissoes from '../../middleware/Permissoes'

function MeuPainel () {
    return (
        <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'consultor', 'desenvolvedor', 'suporte', 'dashboard_meu_painel']}>
            <div id = 'meuPainelDados'>
                <ResumoTarefas />
                <UltimosAtendimentos />
                <GraficoProdutividade/>
                <GraficoNpsAtendimento />
            </div>
        </Permissoes>
    )
}

export default MeuPainel